import styled from 'styled-components';

export const PageContainer = styled.div`
  min-height: 100vh;
  background: #f3f4f8;
  color: #222247;
  font-family: 'Biotif', sans-serif;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.header`
  width: 100%;
  padding: 20px 32px;
  background: #ffffff;
  border-bottom: 1px solid #e7e8ef;
  font-size: 1.8rem;
  font-weight: 700;
  color: #4948ac;
`;

export const Content = styled.main`
  flex: 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px 16px 32px;
`;

export const Footer = styled.footer`
  width: 100%;
  text-align: center;
  padding: 16px;
  font-size: 1.2rem;
  color: #6d7390;
`;
